import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://qcgmxrnjnqjerbbhrhnz.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFjZ214cm5qbnFqZXJiYmhyaG56Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU5NDkzNjUsImV4cCI6MjA5MTUyNTM2NX0.5t2p0NCzq0yr2bWFSFrQLmY5gJapZmIzw76eRskmMk4';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);